import React, { useState, useEffect } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import LoginDesktop from "./LoginDesktop";
import LoginMobile from "./LoginMobile";

const Login = ({ setAuthenticated }) => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(max-width: 768px)");

        const handleResize = (e) => setIsMobile(e.matches);

        // Set initial state
        setIsMobile(mediaQuery.matches);

        // Listen for changes
        mediaQuery.addEventListener("change", handleResize);

        // Cleanup listener on unmount
        return () => mediaQuery.removeEventListener("change", handleResize);
    }, []);

    return isMobile ? (
        <LoginMobile setAuthenticated={setAuthenticated} />
    ) : (
        <LoginDesktop setAuthenticated={setAuthenticated} />
    );
};

export default Login;
